/**
 * Report Builder - Place Page Break JavaScript
 *
 * Manages page break placement on the report canvas
 */

(function () {
  "use strict";

  // Store placed page breaks
  let placedPageBreaks = [];
  let pageBreakCounter = 0;
  let isAddingPageBreakPlaceholder = false;

  /**
   * Initialize the place page break functionality
   */
  function initPlacePageBreak() {
    // This will be called from the toolbar button click
  }

  /**
   * Add page break directly to canvas (no configuration needed)
   */
  function addPageBreakPlaceholder() {
    // Prevent duplicate calls
    if (isAddingPageBreakPlaceholder) {
      return;
    }

    isAddingPageBreakPlaceholder = true;

    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (!canvasCharts) {
      isAddingPageBreakPlaceholder = false;
      return;
    }

    // Hide empty message
    if (window.ReportBuilderUtils?.toggleEmptyMessage) {
      window.ReportBuilderUtils.toggleEmptyMessage(false);
    }

    // Create unique page break ID
    const pageBreakItemId = `report_page_break_${++pageBreakCounter}_${Date.now()}`;

    // Create page break configuration
    const pageBreakConfig = {
      id: pageBreakItemId,
    };

    // Add to placed page breaks
    placedPageBreaks.push(pageBreakConfig);

    // Render page break directly in canvas
    renderPageBreakInCanvas(pageBreakConfig);

    // Reset flag after a short delay
    setTimeout(function () {
      isAddingPageBreakPlaceholder = false;
    }, 100);
  }

  /**
   * Render page break in canvas
   */
  function renderPageBreakInCanvas(pageBreakConfig) {
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (!canvasCharts) {
      return;
    }

    // Create page break container
    const pageBreakContainer = document.createElement("div");
    pageBreakContainer.className = "canvas-page-break-item";
    pageBreakContainer.id = `page_break_container_${pageBreakConfig.id}`;
    pageBreakContainer.setAttribute("data-page-break-id", pageBreakConfig.id);

    // Create page break header with controls
    const pageBreakHeader = document.createElement("div");
    pageBreakHeader.className = "page-break-item-header";
    const displayTitle = "Page Break";

    if (window.ReportBuilderUtils?.generateItemHeaderHtml) {
      pageBreakHeader.innerHTML =
        window.ReportBuilderUtils.generateItemHeaderHtml({
          itemId: pageBreakConfig.id,
          displayTitle: displayTitle,
          idAttribute: "data-page-break-id",
          itemType: "page-break",
          removeButtonClass: "btn-remove-page-break",
          removeButtonTitle: "Remove page break",
          hideEditTitle: true, // Page breaks don't need custom titles
        });
    } else {
      // Fallback if utils not available
      pageBreakHeader.innerHTML = `<div class="page-break-item-title"><h4>${displayTitle}</h4></div>`;
    }

    // Create page break content area (visual indicator)
    const pageBreakContent = document.createElement("div");
    pageBreakContent.className = "page-break-item-content";
    pageBreakContent.innerHTML = `
      <div class="page-break-visual">
        <div class="page-break-line"></div>
        <span class="page-break-label">New Page Starts Here</span>
        <div class="page-break-line"></div>
      </div>
    `;

    // Assemble page break container
    pageBreakContainer.appendChild(pageBreakHeader);
    pageBreakContainer.appendChild(pageBreakContent);

    // Add to canvas
    canvasCharts.appendChild(pageBreakContainer);
    
    // Scroll to the new page break
    pageBreakContainer.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });

    // Setup move buttons
    if (window.ReportBuilderUtils?.setupMoveButtons) {
      window.ReportBuilderUtils.setupMoveButtons(
        pageBreakContainer,
        pageBreakConfig.id,
        "data-page-break-id",
        function () {
          updatePageBreakArrayOrder(pageBreakConfig.id);
        }
      );
    }

    // Setup remove button
    const removeBtn = pageBreakContainer.querySelector(
      ".btn-remove-page-break"
    );
    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        if (window.ReportBuilderUtils?.showConfirmationModal) {
          window.ReportBuilderUtils.showConfirmationModal({
            title: "Remove Page Break",
            message: "Are you sure you want to remove this page break?",
            confirmText: "Remove",
            cancelText: "Cancel",
            onConfirm: function() {
              removePageBreak(pageBreakConfig.id);
            }
          });
        } else {
          // Fallback if modal not available
          if (confirm("Are you sure you want to remove this page break?")) {
            removePageBreak(pageBreakConfig.id);
          }
        }
      });
    }
  }

  /**
   * Update page break array order to match DOM order
   */
  function updatePageBreakArrayOrder(pageBreakId) {
    if (window.ReportBuilderUtils?.updateArrayOrder) {
      window.ReportBuilderUtils.updateArrayOrder(
        placedPageBreaks,
        pageBreakId,
        "page_break_container_",
        "data-page-break-id"
      );
    }
  }

  /**
   * Remove page break from canvas
   */
  function removePageBreak(pageBreakId) {
    // Remove from placed page breaks array
    placedPageBreaks = placedPageBreaks.filter(
      (pb) => pb.id !== pageBreakId
    );

    // Remove from DOM
    const pageBreakContainer = document.getElementById(
      `page_break_container_${pageBreakId}`
    );
    if (pageBreakContainer) {
      pageBreakContainer.remove();
    }

    // Show empty message if no items left
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (canvasCharts && canvasCharts.children.length === 0) {
      if (window.ReportBuilderUtils?.toggleEmptyMessage) {
        window.ReportBuilderUtils.toggleEmptyMessage(true);
      }
    }
  }

  // Export functions for external use
  window.ReportBuilderPageBreak = {
    addPageBreakPlaceholder: addPageBreakPlaceholder,
    removePageBreak: removePageBreak,
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPlacePageBreak);
  } else {
    initPlacePageBreak();
  }
})();
